import { Component, ErrorInfo, ReactNode } from 'react';
import { I18nProvider, useI18n } from './i18n';
import { trackFunnel } from './funnel';

interface Props {
    /** jméno z data-react-component — do konzole, ať je poznat, který ostrov spadl */
    name: string;
    /** katalog pro hlášku fallbacku (ostrovy ho dostávají v data-props) */
    translationsUrl: string | null;
    children?: ReactNode;
}

/**
 * React 19 při nezachycené chybě odmountuje celý root — v košíku by po pádu
 * zůstalo prázdné místo a zákazník nemá jak pokračovat. Boundary chybu zachytí,
 * nechá stránku použitelnou a vypíše ji i s component stackem do konzole
 * (sbírá LogRocket, takže je z relace vidět, která komponenta padla).
 */
export default class ErrorBoundary extends Component<Props, { failed: boolean }> {

    state = { failed: false };

    static getDerivedStateFromError(): { failed: boolean } {
        return { failed: true };
    }

    componentDidCatch(error: Error, info: ErrorInfo): void {
        console.error(`[react] Komponenta "${this.props.name}" spadla.`, error, info.componentStack);
        trackFunnel('ReactIslandCrashed', { component: this.props.name, message: error.message });
    }

    render(): ReactNode {
        if (!this.state.failed) {
            return this.props.children;
        }

        return (
            <I18nProvider url={this.props.translationsUrl}>
                <IslandError />
            </I18nProvider>
        );
    }

}

function IslandError() {
    const t = useI18n();

    return (
        <div className="msg msg--error" role="alert">
            <p>{t('Something went wrong. Please try again.')}</p>
            <button type="button" className="btn btn--custom-1" onClick={() => window.location.reload()}>
                <span>{t('Reload page')}</span>
            </button>
        </div>
    );
}
